import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	Icon,
} from '@uturn/ui-kit';
import { useTranslation } from 'react-i18next';

type Props = {
	open: boolean;
	onSubmit: () => void;
	onCancel: () => void;
	isSubmitting?: boolean;
};

export const CreditLimitPublishBlockedModal = ({
	open,
	onSubmit,
	onCancel,
	isSubmitting,
}: Props) => {
	const { t } = useTranslation();

	return (
		<AlertDialog open={open}>
			<AlertDialogContent className="max-w-[25rem] md:max-w-[40rem]">
				<AlertDialogHeader>
					<AlertDialogTitle className="flex items-center gap-2">
						<Icon
							icon={faExclamationCircle}
							className="size-5 text-destructive"
							aria-hidden
						/>
						{t(
							'pages.shipment-create.credit-limit-publish-blocked-modal.title',
							"You've reached your credit limit.",
						)}
					</AlertDialogTitle>
					<AlertDialogDescription>
						{t(
							'pages.shipment-create.credit-limit-publish-blocked-modal.description',
							'New shipments cannot be published at this moment. You can still save this shipment as a draft and publish it later once your payments have been processed or your limit has been increased.',
						)}
					</AlertDialogDescription>
				</AlertDialogHeader>

				<AlertDialogFooter>
					<AlertDialogCancel onClick={onCancel}>
						{t(
							'pages.shipment-create.credit-limit-publish-blocked-modal.cancel',
							'Cancel',
						)}
					</AlertDialogCancel>
					<AlertDialogAction onClick={onSubmit} disabled={isSubmitting}>
						{t(
							'pages.shipment-create.credit-limit-publish-blocked-modal.confirm',
							'Save as a concept',
						)}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};
